export const SET_STORAGE_EXPECTED_INCOME = 'SET_STORAGE_EXPECTED_INCOME';
export const SET_STORAGE_EXPECTED_FIRST_CHARGE = 'SET_STORAGE_EXPECTED_FIRST_CHARGE';
export const CLEAR_STORAGE_EXPECTED_INCOME = 'CLEAR_STORAGE_EXPECTED_INCOME';

